<template>
  <div class="container has-text-left">
    <b-field>
      <p class="control">
        <b-dropdown v-model="method" aria-role="list">
          <b-button type="is-primary" slot="trigger">{{method}}</b-button>
          <b-dropdown-item
              v-for="optMethod in allowedMethods"
              :key="optMethod"
              :value="optMethod"
              aria-role="listitem"
          >
            <span>{{optMethod.toUpperCase()}}</span>
          </b-dropdown-item>
        </b-dropdown>
      </p>

      <b-input placeholder="http://" v-model="url" style="width: 100%;"/>
    </b-field>

    <b-field>
      <p class="control">
        <b-button type="is-primary">Timeout:</b-button>
      </p>

      <b-input placeholder="5000" v-model="timeout" style="width: 100%;"/>
    </b-field>

    <b-collapse
        aria-id="contentIdForRequestHeaders"
        animation="slide"
        v-model="headersOpened"
    >
      <div
          slot="trigger"
          role="button"
          aria-controls="contentIdForRequestHeaders"
      >
        Headers
      </div>
    </b-collapse>

    <b-collapse
        aria-id="contentIdForRequestBody"
        animation="slide"
        v-model="bodyOpened"
    >
      <div
          slot="trigger"
          role="button"
          aria-controls="contentIdForRequestBody"
      >
        Body
      </div>
    </b-collapse>

    <div class="buttons" style="margin-top: 1rem;">
      <b-button type="is-primary" @click="handleSend">Send</b-button>
      <b-button type="is-warning" v-if="response" @click="handleSave" :disabled="saved">Save</b-button>
    </div>

    <hr v-if="requestState > 0"/>

    <div class="container has-text-left" v-if="response">
      <div class="level">
        <div class="level-right">
          <div class="level-item">
            <span>Status: {{responseStatus}}</span>
          </div>
          <div class="level-item">
            <span>Time: {{elapsed}} ms</span>
          </div>
        </div>
      </div>
      <div class="container has-text-left" v-if="responseBody">
        <json-viewer :value="responseBody" :expand-depth="5" copyable/>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BDropdown from "buefy/src/components/dropdown/Dropdown";
  import BDropdownItem from "buefy/src/components/dropdown/DropdownItem";
  import BButton from "buefy/src/components/button/Button";
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BCollapse from "buefy/src/components/collapse/Collapse";
  import JsonViewer from 'vue-json-viewer';

  export default {
    components: {
      BCollapse,
      BInput,
      BField,
      BButton,
      BDropdownItem,
      BDropdown,
      JsonViewer
    },
    name: "request",
    props: ['params', 'onSave'],
    data() {
      return {
        requestId: 0,
        url: 'http://10.0.8.3:9111/',
        timeout: 5000,
        method: 'GET',
        headers: {},
        body: {},
        headersOpened: true,
        bodyOpened: false,
        saved: false
      };
    },
    watch: {
      url() {
        this.saved = false;
      },
      timeout() {
        this.saved = false;
      },
      method() {
        this.saved = false;
      },
      headers() {
        this.saved = false;
      },
      body() {
        this.saved = false;
      }
    },
    computed: {
      ...mapGetters('requester', ['allowedMethods', 'requestState', 'response', 'requestStartTime', 'requestEndTime']),
      responseStatus() {
        if (!this.response) {
          return '-';
        }

        return this.response.status;
      },
      responseBody() {
        if (!this.response) {
          return null;
        }

        return this.response.data;
      },
      elapsed() {
        return this.requestEndTime - this.requestStartTime;
      }
    },
    methods: {
      ...mapActions('requester', ['sendRequest']),
      handleSend() {
        this.sendRequest({
          _url: this.url,
          _method: this.method,
          _headers: this.headers,
          _data: this.body,
          _timeout: this.timeout
        });
      },
      handleSave() {
        this.$emit('save', {
          requestId: this.requestId,
          content: {
            url: this.url,
            method: this.method,
            headers: this.headers,
            data: this.body,
            timeout: this.timeout
          }
        });
        this.saved = true;
      }
    },
    mounted() {
      if (this.params) {
        /* eslint-disable */
        console.log('TODO: init with params...');
      }
    },
    unmounted() {
      this.saved = false;
    }
  }
</script>

<style scoped>

</style>